import React, { useMemo, useState, useEffect, useCallback,useRef  } from 'react';
import axiosApi from '../Utils/axiosApi';
import { useTable } from 'react-table';
import HeaderMenu from '../Header/HeaderMenu';
import checkPermission from '../Utils/checkPermission';
import {
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Alert,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { API_BASE_URL } from '../../config';

const HotelBookingList = () => {
  //const [visits, setVisits] = useState([]);
  const [filteredVisits, setFilteredVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState(null);

  const [hostelList, setHostelList] = useState([]);
  const [pendingHostelFilter, setPendingHostelFilter] = useState('');
  const [bookingNameFilter, setBookingNameFilter] = useState('');

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [bookingToDelete, setBookingToDelete] = useState(null);

  const [modalMessage, setModalMessage] = useState({ type: '', text: '' });
const alertRef = useRef(null);
  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const response = await axiosApi.post(
        `${API_BASE_URL}/hostelBookingRequestInfo/getHostelBooking`,
        {}
      );
      const bookings = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      //setVisits(bookings);
      setFilteredVisits(bookings);
    } catch (error) {
      console.error('Error fetching bookings:', error);
      //setVisits([]);
      setFilteredVisits([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    axiosApi
      .post('/hostel/getHostelName', {})
      .then((response) => {
        const data = Array.isArray(response.data)
          ? response.data
          : response.data.hostels || [];
        const formatted = data.map(([id, name]) => ({ id, hostelName: name }));
        setHostelList(formatted);
      })
      .catch((error) => console.error('Error fetching hostels:', error));
  }, []);

  const handleSearch = async () => {
    try {
      const selectedHostel = hostelList.find(
        (h) => h.hostelName === pendingHostelFilter
      );
      const requestBody = {
        hostelIds: selectedHostel?.id ? [selectedHostel.id] : [],
        applicantFullName: bookingNameFilter || null,
      };
      const response = await axiosApi.post(
        `${API_BASE_URL}/hostelBookingRequestInfo/getHostelBooking`,
        requestBody
      );
      const bookings = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setFilteredVisits(bookings);
    } catch (error) {
      console.error('Error fetching filtered bookings:', error);
      setFilteredVisits([]);
    }
  };

  const handleReset = async () => {
    setPendingHostelFilter('');
    setBookingNameFilter('');
    fetchBookings();
  };

  const handleViewBooking = (hostelBooking) => {
    axiosApi
      .post(`${API_BASE_URL}/hostelBookingRequestInfo/getHostelBooking`, {
        hostelBookingIds: [hostelBooking.id],
        hostelIds: [],
        applicantFullName: null,
      })
      .then((response) => {
        const details =
          Array.isArray(response.data) && response.data.length > 0
            ? response.data[0]
            : response.data;
        setSelectedVisit({ ...details });
        setModalMessage({ type: '', text: '' });
        setIsDialogOpen(true);
      })
      .catch((err) =>
        console.error('Error fetching hostelBooking details:', err)
      );
  };

  const handleDelete = useCallback((id) => {
    setBookingToDelete(id);
    setConfirmDialogOpen(true);
  }, []);

  const confirmDelete = () => {
    if (!bookingToDelete) return;
    axiosApi
      .post('/hostelBookingRequestInfo/deleteHostelBooking', {
        hostelBookingIds: [bookingToDelete],
      })
      .then(() => {
        fetchBookings();
        setModalMessage({
          type: 'success',
          text: `Hostel Booking with ID ${bookingToDelete} has been deleted.`,
        });
      })
      .catch((error) => {
        console.error('Error deleting hostel booking:', error);
        setModalMessage({
          type: 'error',
          text: 'Failed to delete the hostel booking. Please try again.',
        });
      })
      .finally(() => {
        setConfirmDialogOpen(false);
        setBookingToDelete(null);
      });
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        hostelBookingRequestInfoDTO: {
          id: selectedVisit.id,
          bookingStatus: selectedVisit.bookingStatus,
          remark: selectedVisit.remark || '',
        },
      };
      await axiosApi.post(
        `${API_BASE_URL}/hostelBookingRequestInfo/updateHostelBooking`,
        payload
      );
      fetchBookings();
      setModalMessage({
        type: 'success',
        text: 'Booking updated successfully.',
      });
	  setTimeout(() => {
      alertRef.current?.focus();
    }, 100);
    } catch (error) {
      console.error('Error updating booking:', error);
      setModalMessage({
        type: 'error',
        text: 'Failed to update booking. Please try again.',
      });
	  setTimeout(() => {
      alertRef.current?.focus();
    }, 100);
    }
  };

  const columns = useMemo(
    () => [
      { Header: '#', accessor: '' },
      { Header: 'Booking ID', accessor: 'hostelBookingId' },
      { Header: 'Applicant Name', accessor: 'applicantFullName' },
      { Header: 'Email', accessor: 'applicantEmail' },
      { Header: 'Mobile Number', accessor: 'applicantMobileNumber' },
      { Header: 'Property Name', accessor: 'hostelName' },
      { Header: 'Booking Status', accessor: 'bookingStatus' },
      {
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({ row }) => (
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button disabled={!checkPermission("Hostel", "Booking List", "VIEW")}
              size="small"
              variant="outlined"
              onClick={() => handleViewBooking(row.original)}
            >
              Manage
            </Button>
            <Button disabled={!checkPermission("Hostel", "Booking List", "DELETE")}
              size="small"
              color="error"
              variant="outlined"
              onClick={() => handleDelete(row.original.id)}
            >
              Delete
            </Button>
          </div>
        ),
      },
    ],
    [handleDelete]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: filteredVisits });

  return (
    <div>
      <HeaderMenu />
      <h2>Hostel Booking List</h2>

      {/* Filters */}
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          p: 2,
          borderRadius: 2,
          mb: 3,
          boxShadow: 1,
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4} md={3}>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel>Property Name</InputLabel>
              <Select
                value={pendingHostelFilter}
                onChange={(e) => setPendingHostelFilter(e.target.value)}
                label="Property Name"
              >
                <MenuItem value="">All</MenuItem>
                {hostelList.map((hostel) => (
                  <MenuItem key={hostel.id} value={hostel.hostelName}>
                    {hostel.hostelName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Applicant Name"
              variant="outlined"
              size="small"
              fullWidth
              value={bookingNameFilter}
              onChange={(e) => setBookingNameFilter(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={2} md={2}>
            <Button
              fullWidth
              variant="contained"
              size="small"
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
          <Grid item xs={6} sm={2} md={2}>
            <Button
              fullWidth
              variant="outlined"
              size="small"
              color="secondary"
              onClick={handleReset}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Table */}
      {loading ? (
        <p>Loading hostel bookings...</p>
      ) : (
        <div className="table-container">
          <table {...getTableProps()} className="table">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render('Header')}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={columns.length}>No matching bookings found.</td>
                </tr>
              ) : (
                rows.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.original.id}>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          data-label={cell.column.Header}
                          key={cell.column.id}
                        >
                          {cell.render('Cell') || 'N/A'}
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Manage Dialog */}
     {/* Manage Dialog */}
<Dialog
  open={isDialogOpen}
  onClose={() => setIsDialogOpen(false)}
  fullWidth
  maxWidth="md"
>
  <DialogTitle>Manage Booking</DialogTitle>
  <DialogContent dividers>
    {modalMessage.text && (
    <Alert
      severity={modalMessage.type}
      sx={{ mb: 2 }}
      tabIndex={-1}       // Make it focusable
      ref={alertRef}      // Attach the ref
    >
      {modalMessage.text}
    </Alert>
  )}
    {selectedVisit && (
      <Grid container spacing={2}>
        {/* Row 1 */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Applicant Name"
            value={selectedVisit.applicantFullName || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Applicant Email"
            value={selectedVisit.applicantEmail || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>

        {/* Row 2 */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Mobile Number"
            value={selectedVisit.applicantMobileNumber || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Gender"
            value={selectedVisit.applicantGender || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>

        {/* Row 3 */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Applicant Location"
            value={selectedVisit.applicantLocation || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Permanent Address"
            value={selectedVisit.permanentAddress || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>

        {/* Row 4 */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Hostel Name"
            value={selectedVisit.hostelName || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Booking ID"
            value={selectedVisit.hostelBookingId || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>

        {/* Row 5 */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Preferred Room Type"
            value={selectedVisit.preferredRoomType || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Joining Date"
            value={selectedVisit.hostelJoiningDate || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>

        {/* Row 6 */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Planned End Date"
            value={selectedVisit.plannedAccommodationEndDate || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
        

        

        {/* Row 9 */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Country"
            value={selectedVisit.countryName || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="State"
            value={selectedVisit.stateName || ''}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>

        {/* Editable Fields */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Booking Status</InputLabel>
            <Select
              value={selectedVisit.bookingStatus || ''}
              onChange={(e) =>
                setSelectedVisit({
                  ...selectedVisit,
                  bookingStatus: e.target.value,
                })
              }
            >
              <MenuItem value="PENDING">Pending</MenuItem>
              <MenuItem value="APPROVED">Approved</MenuItem>
              <MenuItem value="REJECTED">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Remark"
            multiline
            rows={3}
            value={selectedVisit.remark || ''}
            onChange={(e) =>
              setSelectedVisit({
                ...selectedVisit,
                remark: e.target.value,
              })
            }
            fullWidth
          />
        </Grid>
      </Grid>
    )}
  </DialogContent>
  <DialogActions>
    <Button disabled={!checkPermission("Hostel", "Booking List", "CREATE")} onClick={handleUpdate} variant="contained">
      Update
    </Button>
    <Button
      onClick={() => setIsDialogOpen(false)}
      variant="outlined"
      color="secondary"
    >
      Close
    </Button>
  </DialogActions>
</Dialog>


      {/* Delete Confirmation Dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this booking?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Yes, Delete
          </Button>
          <Button
            onClick={() => setConfirmDialogOpen(false)}
            variant="outlined"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HotelBookingList;
